/* eslint-disable import/prefer-default-export */
import { schema } from 'normalizr';
import { domainsEntity } from './domain.schema';
import { groupsEntity } from './group.schema';

export const clustersEntity = new schema.Entity('clusters', {
  groups: [groupsEntity]
});
